import $ from "jquery"
window.$ = $
window.jQuery = $
export { $ as $, $ as jQuery }
